import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const MockTestCard = () => {
  const [isHovered, setIsHovered] = useState(false);

  const navigate = useNavigate();

  const cardStyle = {
    width: "380px",
    border:"1px solid #ddd",
    borderRadius: "20px",
    padding: "2px",
    boxShadow: isHovered
      ? "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px"
      : "rgba(50, 50, 93, 0.25) 0px 2px 5px -1px, rgba(0, 0, 0, 0.3) 0px 1px 3px -1px",
    transition: "all 0.3s ease",
    cursor: "pointer",
    fontFamily:
      '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
  };

  const innerCardStyle = {
    background: "#ffffff",
    borderRadius: "18px",
    padding: "28px",
    height: "100%",
  };

  const headerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "20px",
  };

  const badgeStyle = {
    background: "#ff8000",
    color: "#ffffff",
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "600",
    letterSpacing: "0.5px",
    textTransform: "uppercase",
  };

  const titleStyle = {
    fontSize: "24px",
    fontWeight: "700",
    color: "#1a202c",
    marginBottom: "8px",
    lineHeight: "1.3",
  };

  const subtitleStyle = {
    fontSize: "14px",
    color: "#718096",
    marginBottom: "24px",
  };

  const statsContainerStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(3, 1fr)",
    gap: "16px",
    marginBottom: "24px",
    paddingBottom: "24px",
    borderBottom: "1px solid #e2e8f0",
  };

  const statBoxStyle = {
    textAlign: "center",
  };

  const statValueStyle = {
    fontSize: "22px",
    fontWeight: "700",
    background: "#454545",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    backgroundClip: "text",
    marginBottom: "4px",
  };

  const statLabelStyle = {
    fontSize: "12px",
    color: "#718096",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    fontWeight: "500",
  };

  const featuresStyle = {
    marginBottom: "24px",
  };

  const featureItemStyle = {
    display: "flex",
    alignItems: "center",
    marginBottom: "12px",
    fontSize: "14px",
    color: "#4a5568",
  };

  const checkIconStyle = {
    width: "20px",
    height: "20px",
    background: "oklch(76.5% 0.177 163.223)",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginRight: "12px",
    flexShrink: 0,
  };

  const buttonStyle = {
    width: "100%",
    background: "#343434",
    color: "#ffffff",
    border: "none",
    padding: "14px 24px",
    borderRadius: "12px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.3s ease",
    transform: isHovered ? "scale(1)" : "scale(1)",
  };

  return (
    <div className="container py-5">
      <div
        style={cardStyle}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <div style={innerCardStyle}>
          <div style={headerStyle}>
            <div style={badgeStyle}>Free</div>
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="url(#gradient)"
              strokeWidth="2"
            >
              <defs>
                <linearGradient
                  id="gradient"
                  x1="0%"
                  y1="0%"
                  x2="100%"
                  y2="100%"
                >
                  <stop offset="0%" stopColor="#667eea" />
                  <stop offset="100%" stopColor="#764ba2" />
                </linearGradient>
              </defs>
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
            </svg>
          </div>

          <h2 style={titleStyle}>COMPTIA+ ADV Mock Test 1</h2>
          <p style={subtitleStyle}>
            Complete assessment with detailed analysis
          </p>

          <div style={statsContainerStyle}>
            <div style={statBoxStyle}>
              <div style={statValueStyle}>50</div>
              <div style={statLabelStyle}>Questions</div>
            </div>
            <div style={statBoxStyle}>
              <div style={statValueStyle}>90</div>
              <div style={statLabelStyle}>Minutes</div>
            </div>
            <div style={statBoxStyle}>
              <div style={statValueStyle}>100</div>
              <div style={statLabelStyle}>Marks</div>
            </div>
          </div>

          <div style={featuresStyle}>
            <div style={featureItemStyle}>
              <div style={checkIconStyle}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2 6l2.5 2.5L10 3"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span>Detailed performance analytics</span>
            </div>
            <div style={featureItemStyle}>
              <div style={checkIconStyle}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2 6l2.5 2.5L10 3"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span>Instant results</span>
            </div>
            <div style={featureItemStyle}>
              <div style={checkIconStyle}>
                <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                  <path
                    d="M2 6l2.5 2.5L10 3"
                    stroke="white"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </div>
              <span>Percentile ranking system</span>
            </div>
          </div>

          <button onClick={() => navigate("/mock-test")} style={buttonStyle}>
            Start Mock Test →
          </button>
        </div>
      </div>
    </div>
  );
};

export default MockTestCard;


